export default __webpack_public_path__ + "static/media/english-mentor.e919429c.jpg";